import { ImageUploadForm } from '@shared/components';
import { Box } from '@mui/material';
import { UserResponse } from '@api/auth/model/types';

interface UserImageChangerProps {
  imageUrl?: string;
  onImageChange?: (userImageResponse: UserResponse) => void;
  onImageError?: () => void;
}

function UserImageChanger(props: UserImageChangerProps) {
  const { imageUrl, onImageChange, onImageError } = props;

  return (
    <Box sx={{ width: '512px' }}>
      <ImageUploadForm
        imageUrl={imageUrl}
        onFileUpload={onImageChange}
        onImageError={onImageError}
      />
    </Box>
  );
}

export default UserImageChanger;
